import { Injector, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, FrameContext, IButtonViewRule } from '@farris/devkit';
@Pipe({ name: 'buttonUsability' })
export class ButtonUsabilityPipe implements PipeTransform {
  constructor(protected injector: Injector, protected formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry, protected frameContext: FrameContext) {
  }
  /**
   * è®¡ç®å·¥å·æ æé®æ¯å¦å¯ç¨
   * @param value - toolbarItemç¼å·åå¶å½åå¼
   * @param buttonId - å·¥å·æ idï¼éåé¨æé®é¡¹id
   * @param version - version
   * @description æé®å¼ä¸ºtrueæ¶è¡¨ç¤ºç¦ç¨ï¼falseæ¶è¡¨ç¤ºå¯ç¨
   */
  transform(value: any, buttonId: string, version: any) {
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      return value;
    }
    const element = this.formElementRegistry.getElementById(buttonId);
    if (element) {
      const viewRule = this.viewRuleRegistry.getRuleById(buttonId) as IButtonViewRule;
      if (viewRule) {
        // å¼ä¸ºtrueæ¶è¡¨ç¤ºç¦ç¨ï¼falseæ¶è¡¨ç¤ºå¯ç¨
        const ruleDisabled = viewRule.disabled;
        const elementRule = element.rules.find((item: IFormRule) => item.type === Farris.FormRule.RuleType.Disabled);
        // è§åè®¾ç½®ä¸ºå¯ç¨
        if (!ruleDisabled) {
          if (!elementRule.dynamic) {
            value = false;
          }
        } else {
          value = true;
        }
      }
    }
    return value;
  }
}
